/**************************************************
 * Nombre:       Galeria_Imagenes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import dos from "../../../../Recursos/img_dos.png";
import tres from "../../../../Recursos/img_tres.png";
import cuatro from "../../../../Recursos/img_cuatro.png";
import cinco from "../../../../Recursos/img_cinco.png";
import seis from "../../../../Recursos/img_seis.png";
import uno from "../../../../Recursos/img_uno.png";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Galeria_Imagenes = () => {
    const {sCell} = useResponsive()
    const grande = sCell ? 350 : 640

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            <Grid container size={{xs: 3, sm: 3, md: 3}}
                  sx={{
                      width: sCell ? '21%' : '100%',
                      height: grande,
                      backgroundImage: `url(${uno})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      borderRadius: sCell ? 4 : 8
                  }}

            />

            <Grid container size={{xs: 9, sm: 9, md: 9}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid container size={{xs: 6, sm: 6, md: 6}}
                          sx={{
                              width: sCell ? '46%' : '100%',
                              height: grande / 1.5,
                              backgroundImage: `url(${dos})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat',
                              borderRadius: sCell ? 4 : 8
                          }}

                    />

                    <Grid container size={{xs: 6, sm: 6, md: 6}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 6, sm: 6, md: 6}}
                                  sx={{
                                      width: sCell ? '43%' : '100%',
                                      height: grande / 1.5,
                                      backgroundImage: `url(${tres})`,
                                      backgroundSize: 'cover',
                                      backgroundPosition: 'center',
                                      backgroundRepeat: 'no-repeat',
                                      borderRadius: sCell ? 4 : 8
                                  }}

                            />

                            <Grid container size={{xs: 6, sm: 6, md: 6}}>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{
                                              width: '100%',
                                              height: grande / 3.1,
                                              backgroundImage: `url(${cuatro})`,
                                              backgroundSize: 'cover',
                                              backgroundPosition: 'center',
                                              backgroundRepeat: 'no-repeat',
                                              borderRadius: sCell ? 4 : 8
                                          }}

                                    />

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{
                                              width: '100%',
                                              height: grande / 3.1,
                                              backgroundImage: `url(${cinco})`,
                                              backgroundSize: 'cover',
                                              backgroundPosition: 'center',
                                              backgroundRepeat: 'no-repeat',
                                              borderRadius: sCell ? 4 : 8
                                          }}

                                    />

                                </Grid>


                            </Grid>


                        </Grid>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{
                              width: '100%',
                              height: grande / 3.2,
                              backgroundImage: `url(${seis})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat',
                              borderRadius: sCell ? 4 : 8
                          }}

                    />


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Galeria_Imagenes